import { Children } from 'react';
import clsx from 'clsx';
import { useDeviceType } from '@cian/ui-kit/responsive';
import * as styles from './styles.css';

interface ICarouselProps {
  children: React.ReactNode;
  emblaRef: (instance: HTMLDivElement | null) => void;
}

export const Carousel: React.FC<ICarouselProps> = ({ children, emblaRef }) => {
  const device = useDeviceType();

  return (
    <div className={styles['embla-root']}>
      <div className={clsx(styles['embla-viewport'], styles[device])} ref={emblaRef}>
        <div className={styles['embla-container']}>
          {Children.map(children, (child, index) => (
            <div className={styles['embla-slide']} key={index}>
              {child}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
